import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import Dashboard from '../views/Dashboard.vue'
import PropertyList from '../views/PropertyList.vue'
import Analytics from '../views/Analytics.vue'
import DataImport from '../views/DataImport.vue'
import Settings from '../views/Settings.vue'
import DevDocs from '../views/DevDocs.vue'
import Users from '../views/Users.vue'
import Products from '../views/Products.vue'
import Unauthorized from '../views/Unauthorized.vue'
import { useAuthStore } from '../stores/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: { requiresGuest: true }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: Unauthorized,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/properties',
    name: 'property-list',
    component: PropertyList,
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: '/data-import',
    name: 'data-import',
    component: DataImport,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/products',
    name: 'products',
    component: Products,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/dev-docs',
    name: 'dev-docs',
    component: DevDocs,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const isAuthenticated = authStore.isAuthenticated
  const isAdmin = authStore.user?.role === 'admin'

  // Routes that require authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  }
  // Routes that require admin access
  else if (to.meta.requiresAdmin && !isAdmin) {
    next('/unauthorized')
  }
  // Routes that require guest (not authenticated)
  else if (to.meta.requiresGuest && isAuthenticated) {
    next('/dashboard')
  }
  else {
    next()
  }
})

export default router
